import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const customerDeliveryFileDeleteService = (data: any) => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.CUSTOMER_DELIVERY.DELETE_FILE
    : ENDPOINTS.ADMIN.CUSTOMER_DELIVERY.DELETE_FILE;

  return axiosInstance
    .delete(URL, { data })
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
